import { RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  time_labels: {
    today: "Aujourd'hui",
    asap: 'ASAP',
    scheduled: '{{date}}, {{time}}',
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Numéro de chambre',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Numéro de table',
  },
};
